import WizardBlankThumbnail from 'src/images/wizard_blank_thumbnail.png';
import WizardThumbnail from 'src/images/wizard_thumbnail.png';
import WizardInternalTemplatesThumbnail from 'src/images/wizard_internal_thumbnail.png';
import WizardExternalTemplatesThumbnail from 'src/images/wizard_external_thumbnail.png';
import { CreateJourneyCardProps } from 'src/common/components/create-journey/card';
import { NewJourneyType } from 'src/common/interfaces/journey/new-journey-type.enum';

export const CreateJourneyTypes: CreateJourneyCardProps[] = [
  {
    imageSrc: WizardThumbnail,
    text: 'Create using Wizard',
    subText: 'Automagically create Journey',
    type: NewJourneyType.WIZARD,
  },
  {
    imageSrc: WizardBlankThumbnail,
    text: 'Create Journey',
    subText: 'Start creating from scratch',
    type: NewJourneyType.SCRATCH,
  },
  {
    imageSrc: WizardBlankThumbnail,
    text: 'Create Journey 2.0',
    subText: 'Start creating with AI',
    type: NewJourneyType.NEUE_SCRATCH,
  },
];
